import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { RACK_MATERIAL_COLORS, SIDES_DISTANCE } from '@/shared/constants/configurator';
import { DISPLAY_SCALE } from '@/shared/constants/editor';
import { calculateConfiguratorHeight } from '@/shared/lib/configurator';
import styles from './side-editor-sections-connection.module.css';

export const SideEditorSectionsConnection = () => {
	const {
		state: { material, sections },
	} = useConfigurator();

	const height = calculateConfiguratorHeight(sections);

	return (
		<div
			style={{ width: SIDES_DISTANCE * DISPLAY_SCALE, height: height * DISPLAY_SCALE }}
			className={styles.wrapper}
		>
			<div
				style={{ backgroundColor: RACK_MATERIAL_COLORS[material] }}
				className={styles.connection}
			/>
			<div
				style={{ backgroundColor: RACK_MATERIAL_COLORS[material] }}
				className={styles.connection}
			/>
		</div>
	);
};
